export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-save-0605aeea9e50bfb77b32d71b0d0627ff.svg";